import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden w-full bg-background" data-id="element-77">
      <div className="max-w-7xl mx-auto px-6" data-id="element-78">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-79">
          {/* Left Column: Text Content & Mobile Image */}
          <div className="flex flex-col" data-id="element-80">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} className="text-5xl sm:text-6xl lg:text-7xl font-semibold tracking-tight text-primary leading-[1.1]" data-id="element-81">
              Ми створюємо моменти, <br data-id="element-82" />
              <span className="text-secondary" data-id="element-83">що тривають вічно.</span>
            </motion.h1>

            {/* Mobile Image (Visible only on small screens, between Headline and Description) */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 1,
            ease: 'easeOut',
            delay: 0.2
          }} className="block lg:hidden w-full h-[350px] sm:h-[450px] rounded-[2rem] overflow-hidden shadow-xl my-8" data-id="element-84">
              <img src="https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=2070&auto=format&fit=crop" alt="Wedding Event" className="w-full h-full object-cover" data-id="element-85" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut',
            delay: 0.3
          }} className="mt-0 lg:mt-8" data-id="element-86">
              <p className="text-lg md:text-xl text-secondary font-medium mb-10 leading-relaxed" data-id="element-87">
                Ексклюзивна агенція з фокусом на бездоганний сервіс та сучасну
                естетику. Ваш ідеальний захід починається тут.
              </p>

              <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-88">
                <a href="#contact" className="w-full sm:w-auto px-8 py-4 bg-primary text-background rounded-full font-medium flex items-center justify-center gap-2 hover:opacity-90 transition-opacity shadow-lg" data-id="element-89">
                  Обговорити проект
                  <ArrowRight size={18} data-id="element-90" />
                </a>
                <a href="#portfolio" className="w-full sm:w-auto px-8 py-4 bg-surface text-primary rounded-full font-medium hover:bg-border/50 transition-colors border border-border" data-id="element-91">
                  Дивитись роботи
                </a>
              </div>
            </motion.div>
          </div>

          {/* Right Column: Desktop Image (Visible only on large screens) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          x: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          x: 0
        }} transition={{
          duration: 1,
          ease: 'easeOut',
          delay: 0.2
        }} className="hidden lg:block w-full h-[600px] rounded-[2.5rem] overflow-hidden shadow-2xl" data-id="element-92">
            <img src="https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=2070&auto=format&fit=crop" alt="Wedding Event" className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000" data-id="element-93" />
          </motion.div>
        </div>
      </div>
    </section>;
}